import { NavLink } from "react-router-dom";
import media from "../../../media";

export default function Sidebar2({ collapsed }) {
  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-logo">
        {collapsed ? (
          <NavLink to="/dashboard" className="menu-link">
            <img alt="Logo" src={media.login_logo} className="img-icon mt-3" />
          </NavLink>
        ) : (
          <NavLink to="/dashboard" className="menu-link">
            <img alt="Logo" src={media.newlogo} className="img-logo" />
          </NavLink>
        )}
      </div>

      <div className="sidebar-menu">
        <ul>
          <li>
            <NavLink
              to="/dashBoard"
              className={({ isActive }) =>
                `menu-link ${isActive ? "active" : ""}`
              }
            >
              <i className="fas fa-home menu-icon"></i>
              {!collapsed && <span>Dashboard</span>}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/agents"
              className={({ isActive }) =>
                `menu-link ${isActive ? "active" : ""}`
              }
            >
              <i className="fas fa-users menu-icon"></i>
              {!collapsed && <span>Agents</span>}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/attendance"
              className={({ isActive }) =>
                `menu-link ${isActive ? "active" : ""}`
              }
            >
              <i className="fas fa-clipboard-list  menu-icon"></i>
              {!collapsed && <span>Attendance</span>}
            </NavLink>
          </li>
                    <li>
            <NavLink
              to="/Farmers"
              className={({ isActive }) =>
                `menu-link ${isActive ? "active" : ""}`
              }
            >
              <i className="fas fa-user  menu-icon"></i>
              {!collapsed && <span>Farmers</span>}
            </NavLink>
          </li>
        </ul>
      </div>
    </aside>
  );
}
